import { RestClient } from './../Client';
import { buildFileFormData, type FileUploadData } from '../utils';

type UploadResult = {
  [key: `${string}Path`]: string;
  [key: `${string}Encoding`]: string;
};

/**
 * FormDataを生成し、ファイルストレージにアップロードする汎用関数
 * @param fileMap - フォームデータに含めるファイルのマップ（キーはフォームデータのフィールド名、値はImportFileField）
 * @returns UploadResult - アップロードされたファイルのパスとエンコーディング情報
 */
async function uploadFiles(fileMap: Map<string, FileUploadData>): Promise<UploadResult> {
  const formData = buildFileFormData(fileMap);
  return await RestClient.fa.formPost<UploadResult>('/file-storage/upload', formData, {
    largeBody: true,
  });
}

export type { UploadResult };
export { uploadFiles };
